﻿import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterStateSnapshot, RoutesRecognized } from '@angular/router';
import { CONFIG } from '../../../core/config';
import { LanguageService } from '../../../core/language/language.service';
import { SurveyDetails } from '../../../core/models/surveys/survey-details';
import { ParticipantAnswerModel } from '../../../core/models/surveys/participant-answer-model';
import { ProposedAnswer } from '../../../core/models/surveys/proposed-answer';
import { ProposedAnswerSearchModel } from '../../../core/models/surveys/proposed-answer-search-model';
import { Question } from '../../../core/models/surveys/question';
import { Survey } from '../../../core/models/surveys/survey';
import { SecurityService } from '../../../core/services/security.service';
import { SpinnerService } from '../../../core/spinner/spinner.service';
import { ToastService } from '../../../core/toast/toast.service';
import { SharedService } from '../../../shared/shared.service';
import { SurveysService } from '../../surveys.service';
@Component({
    selector: 'survey-details',
    templateUrl: './survey-details.component.html',
    styleUrls: ['./survey-details.component.css']
})
export class SurveyDetailsComponent implements OnInit, OnDestroy {
    public showEndMessage: boolean = false;
    public changed: boolean = false;
    public questionTypes: any;
    public survey: Survey;
    public surveyDetails: SurveyDetails;
    public insertedText: string = '';
    public selectedOptions: ParticipantAnswerModel;
    public question: Question;
    private languageID: number;
    private ordNum: number;
    public pathname: string;
    public answers: ProposedAnswer[] = [];
    public lastAnsweredQuestion: number = 0;
    //
    public optionItems: ProposedAnswer[] = [];
    //
    public answersSearch: ProposedAnswerSearchModel;
    public username: string = '';
    public userId: number;
    public userProfileId: number;
    public anketarId: number;
    public prevUrlID: number;
    public preview: boolean = false;
    public redirect: boolean = false;
    public hours: string;
    public minutes: string;

    constructor(private _surveysService: SurveysService,
        private _sharedService: SharedService,
        private _securityService: SecurityService,
        private _languageService: LanguageService,
        private _route: ActivatedRoute, private _router: Router,
        private _toastService: ToastService,
        private _spinnerService: SpinnerService) {
        this.selectedOptions = new ParticipantAnswerModel();
        this.survey = new Survey();
        this.surveyDetails = new SurveyDetails();
        this.question = new Question();
        this.languageID = this._languageService.selectedLanguageId;
        this.ordNum = 0;
        this.answersSearch = new ProposedAnswerSearchModel();
        this.answersSearch.languageId = this.languageID;
        this.anketarId = CONFIG.profileEnum.Anketar;

    }
    ngOnDestroy(): void {
        if (!this.redirect) {
            this._surveysService.removeSurveyParticipantIDFromLocalStorage();
        }
    }

    ngOnInit() {
        this.pathname = location.pathname;
        this.pathname = this.pathname.replace('/fill-survey', '');
        this.pathname = this.pathname.substring(0, this.pathname.indexOf("survey-question") + "survey-question".length);
        this.questionTypes = CONFIG.questionTypeEnum;
        this._securityService.currentUser.subscribe(result => {
            this.username = result ? result.username : " ";
            this.userId = result ? result.id : 0,
                this.userProfileId = result ? result.profileId : 0
        });

        this._route.params.subscribe(params => {
            let id = params['id'];
            this.prevUrlID = params['prevUrlID'];
            if(params['prevUrlID'])
                this.preview = params['preview'];            

            let surveyParticipantId = parseInt(this._surveysService.getSurveyParticipantID());
            if (id != null) {
                if (isNaN(surveyParticipantId) || surveyParticipantId == null) {
                    this._surveysService.getSurveyBySurveyID(id, this.languageID).subscribe(result => {
                        this.surveyDetails = result;

                        if (!this.surveyDetails.smsverificationRequired || this.userProfileId == CONFIG.profileEnum.Anketar) {
                            if (!this._securityService.isLoggedIn) {
                                var indeksNarednogSlash = location.pathname.indexOf('/', 2);
                                var novaPutanja = location.pathname.substring(indeksNarednogSlash, location.pathname.length);                                
                               
                                this._router.navigate(['/login'], { queryParams: { 'redirectURL': novaPutanja } });
                                //za localhost
                                //this._router.navigate(['/login'], { queryParams: { 'redirectURL': location.pathname } });
                            }
                            else {
                                this._surveysService.addSurveyParticipant(this.surveyDetails.surveyUniqueIdentifier, this.userId).subscribe(result => {
                                    if (result > 0) {
                                        surveyParticipantId = result;
                                        this.getSurveyByID(id, surveyParticipantId);
                                    }
                                });
                            }
                        } else {
                            this._router.navigate(['survey/fill-survey/phone-verification', this.surveyDetails.surveyUniqueIdentifier]);
                        }
                    });

                } else {
                    this.getSurveyByID(id, surveyParticipantId);
                }
            }
        });

        //this._route.params.subscribe(params => {
        //    let id = +params['id'];
        //    let surveyParticipantId = +params['surveyParticipantId'];

        //    if (Number.isNaN(surveyParticipantId) && !this._securityService.isLoggedIn) {
        //        this._router.navigate(['/login']);
        //        return;
        //    }
        //    if (!isNaN(id) && id > 0) {

        //        this.getSurveyByID(id, surveyParticipantId);

        //    } else {
        //        //redirect

        //    }
        //});

    }

    getProposedAnswer() {
        this._surveysService.getProposedAnswersByQuestionId(this.answersSearch).subscribe(result => {
            this.answers = result;
            this.optionItems = this.answers.length > 0 ? this.answers[0].optionItems : [];
            this.getSavedAnswerByQuestionID(this.question.id, this.question.surveyID, this.languageID);
        });
    }
    getQuestionByID(id: number, ordNumber: number) {
        this.changed = false;
        this._surveysService.getQuestionByID(id, this.languageID, ordNumber).subscribe(result => {
            if (result) {
                this.question = result;
                this.ordNum = result.ordinalNumber;
                this.answersSearch.questionID = this.question.id;
                this.getProposedAnswer();
            }
        });
    }
    getSavedAnswerByQuestionID(questionId: number, surveyID: number, languageID: number) {

        this._surveysService.getParticipantAnswerByQuestionID(questionId, surveyID, this.survey.surveyParticipantId, languageID).subscribe(result => {
            this.selectedOptions.surveyId = this.question.surveyID;
            this.selectedOptions.surveyQuestionId = this.question.id;
            this.selectedOptions.selectedAnswers = [];
            this.selectedOptions.surveyParticipantId = this.survey.surveyParticipantId;

            this.selectedOptions.selectedAnswers = result;
            if (this.question.surveyQuestionTypeId == CONFIG.questionTypeEnum.free_text_short.toString()
                || this.question.surveyQuestionTypeId == CONFIG.questionTypeEnum.free_text_long.toString()
                || this.question.surveyQuestionTypeId == CONFIG.questionTypeEnum.date.toString()) {
                this.insertedText = this.selectedOptions.selectedAnswers.length > 0 ? this.selectedOptions.selectedAnswers[0].text : null;
            }
            if (this.question.surveyQuestionTypeId == CONFIG.questionTypeEnum.time.toString()) {
                this.insertedText = this.selectedOptions.selectedAnswers.length > 0 ? this.selectedOptions.selectedAnswers[0].text : '00:00';
                const timeParts = this.insertedText.split(':');
                this.hours = timeParts[0];
                this.minutes = timeParts[1];
                this.updateSelectionTime();
            }
            for (let i = this.selectedOptions.selectedAnswers.length - 1; i >= 0; i--) {

                for (let j = this.answers.length - 1; j >= 0; j--) {
                    if (this.selectedOptions.selectedAnswers[i].answerId == this.answers[j].id) {
                        this.answers[j].checked = true;
                    }
                    for (var k = 0; k < this.answers[j].optionItems.length; k++) {
                        if (this.selectedOptions.selectedAnswers[i].answerOptionId == this.answers[j].optionItems[k].id && this.selectedOptions.selectedAnswers[i].answerId == this.answers[j].id) {
                            this.answers[j].optionItems[k].checked = true;
                        }
                    }
                }
            }
        });
    }
    prevSlide() {
        if (this.validation()) {
            if (this.changed) {
                this.save();
            }
            if (this.ordNum != 1) {
                this.insertedText = '';
                this.optionItems = [];
                this.answers = []
                this.getQuestionByID(this.question.surveyID, this.ordNum - 1);
            } else {
                //redirect
            }
        } else {
            var msg = this._languageService.translate('odgovor_nije_popunjen');
            this._toastService.activate(msg, "alert-danger");
        }
    }
    nextSlide() {
        if (this.validation()) {
          if (this.changed) {
              this.save();
          }
          if (this.ordNum != this.survey.questionNumber) {
              this.insertedText = '';
              this.optionItems = [];
              this.answers = []
              this.selectedOptions.selectedAnswers = [];
              if (this.lastAnsweredQuestion <= this.ordNum) {
                  this.lastAnsweredQuestion = this.ordNum;
              }
              this.getQuestionByID(this.question.surveyID, this.ordNum + 1);
          } else {
              this.showEndMessage = true;
              this.lastAnsweredQuestion = this.ordNum;
          }            
        } else {
            var msg = this._languageService.translate('odgovor_nije_popunjen');
            this._toastService.activate(msg, "alert-danger");
        }
    }

    save() {
        if (this.survey.completedSurvey) {
            return;
        }
        this.selectedOptions.ordNum = this.ordNum;
        this._surveysService.saveAnswers(this.selectedOptions).subscribe(result => {

        });
    }
    updateSelectionRadio(selection) {
        this.changed = true;
        this.selectedOptions.selectedAnswers = [];
        let newSelectedItem = this.addAnswer(selection.target.id, null, null);
        this.selectedOptions.selectedAnswers.push(newSelectedItem);

    }
    updateSelectionCheckbox(selection) {
        this.changed = true;
        if (selection.target.checked) {

            let newSelectedItem = this.addAnswer(selection.target.id, null, null);

            this.selectedOptions.selectedAnswers.push(newSelectedItem);
        } else {
            this.selectedOptions.selectedAnswers = this.selectedOptions.selectedAnswers.filter(x => x.answerId != selection.target.id);
        }
    }

    updateSelectionSelect(selection) {
        this.changed = true;
        this.selectedOptions.selectedAnswers = [];
        if (selection.target.value != 0) {

            let newSelectedItem = this.addAnswer(selection.target.value, null, null);


            this.selectedOptions.selectedAnswers.push(newSelectedItem);
        }
    }
    updateSelectionSingleChoiceGrid(selection) {
        this.changed = true;
        let newSelectedItem = this.addAnswer(selection.target.name, selection.target.value, null);

        var obj = this.selectedOptions.selectedAnswers.find((item) => item.answerId == newSelectedItem.answerId);
        if (obj) {
            obj.answerOptionId = newSelectedItem.answerOptionId;
        } else {
            this.selectedOptions.selectedAnswers.push(newSelectedItem);
        }
    }
    updateSelectionMultipleChoiceGrid(selection) {
        this.changed = true;
        let newSelectedItem = this.addAnswer(selection.target.name, selection.target.value, null);

        if (selection.target.checked) {
            this.selectedOptions.selectedAnswers.push(newSelectedItem);
        } else {
            this.selectedOptions.selectedAnswers = this.selectedOptions.selectedAnswers.filter(x => {
                return (x.answerId != newSelectedItem.answerId || x.answerOptionId != newSelectedItem.answerOptionId)
            });
        }
    }
    updateSelectionText(selection) {
        this.changed = true;
        this.selectedOptions.selectedAnswers = [];
        this.selectedOptions.selectedAnswers.push(this.addAnswer(null, null, selection.target.value));
    }
    updateSelectionDate(date: Date) {
        var selection = date.toISOString().split('T')[0];
        this.changed = true;
        this.selectedOptions.selectedAnswers = [];
        this.selectedOptions.selectedAnswers.push(this.addAnswer(null, null, selection));
    }

    validation(): boolean {       
        if (this.question.surveyQuestionTypeId == CONFIG.questionTypeEnum.multiple_choice_grid.toString() ||
            this.question.surveyQuestionTypeId == CONFIG.questionTypeEnum.checkbox_grid.toString()) {
            let uniqueAnswers = new Set();
            this.selectedOptions.selectedAnswers.forEach(function (obj) {
                uniqueAnswers.add(obj.answerId);
            });
            if (uniqueAnswers.size < this.answers.length) {
                return false;
            }
        } else if (this.selectedOptions.selectedAnswers.length == 0) {
            return false;
        } else if (this.question.surveyQuestionTypeId == CONFIG.questionTypeEnum.free_text_long.toString() ||
            this.question.surveyQuestionTypeId == CONFIG.questionTypeEnum.free_text_short.toString()) {

            if (this.selectedOptions.selectedAnswers[0].text == "")
                return false;
        }
        return true;
    }
    getSurveyByID(id: string, participantId: number) {
        this._surveysService.getSurveyByID(id, participantId, this.languageID).subscribe(result => {
            this.survey = result;
            this.lastAnsweredQuestion = this.survey.lastAnsweredQuestion
            const date = new Date(this.survey.validTo);
            const formattedDate = date.toLocaleDateString('sr-SR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });

            if (this.survey.smsverificationRequired && this.userProfileId != CONFIG.profileEnum.Anketar) {
                if (this.prevUrlID != 1) {
                    this._router.navigate(['survey/fill-survey/phone-verification', this.survey.surveyUniqueIdentifier]);
                }
                else if (this.survey.demographicRequired && this.survey.sexId == null) {
                    this.redirect = true;                    
                    if (this.preview == false) {
                        this._router.navigate(['survey/fill-survey/participant-details', this.survey.surveyUniqueIdentifier]);
                        this._surveysService.saveSurveyParticipantID(this.survey.surveyParticipantId.toString())
                    }
                }
            } else if (this.survey.demographicRequired && this.survey.sexId == null) {
                this.redirect = true;               
                if (this.preview == false) {
                    this._router.navigate(['survey/fill-survey/participant-details', this.survey.surveyUniqueIdentifier]);
                    this._surveysService.saveSurveyParticipantID(this.survey.surveyParticipantId.toString())
                }
            }

            this.survey.validTo = formattedDate;
            (this.survey.lastAnsweredQuestion && !this.survey.completedSurvey) ? this.ordNum = this.survey.lastAnsweredQuestion : null;
            this.getQuestionByID(this.survey.surveyId, this.ordNum == this.survey.questionNumber ? this.ordNum : this.ordNum + 1);
        });
    }
    addAnswer(answerId: number, optionId: number, text: string): any {
        let newSelectedItem = {
            "answerId": answerId,
            "answerOptionId": optionId,
            "text": text
        };

        return newSelectedItem;
    }
    keyPressM(event) {
        if (!isNaN(event.key)) {
            let str = (event.target.value + event.key).slice(-2);
            if (parseInt(str) > 59)
                str = '0' + event.key
            this.minutes = str;
            this.updateSelectionTime();
        }

        return false;
    }
    keyPressH(event) {
        if (!isNaN(event.key)) {
            let str = (event.target.value + event.key).slice(-2);
            if (parseInt(str) > 23)
                str = '0' + event.key
            this.hours = str;
            this.updateSelectionTime();
        }

        return false;
    }
    keyDown(event) {
        if (event.key == 'Backspace' || event.key == 'Delete') {
            return false;
        }
    }
    updateSelectionTime() {
        this.hours = '0' + this.hours;
        this.hours = this.hours.slice(-2);
        this.minutes = '0' + this.minutes;
        this.minutes = this.minutes.slice(-2);
        const time = this.hours + ':' + this.minutes;

        this.changed = true;
        this.selectedOptions.selectedAnswers = [];
        this.selectedOptions.selectedAnswers.push(this.addAnswer(null, null, time));
    }

    redirectToList() {
        let link = "";
        if (this.userProfileId == CONFIG.profileEnum.Anketar) {            
            link = "/survey/all-surveys";
            this._router.navigate([link]);
            return;
        } else if (this.survey.surveyParticipantId == CONFIG.surveyParticipantTypeEnum.javna || this.userId == 0) {
            link = "/survey/public-surveys";
            this._router.navigate([link]);
            return;        
        } else {          
            link = "/survey/my-surveys";
            this._router.navigate([link]);
            return;
        }
    }

}
